var map = {
	"./n-boy.png": "ADRj",
	"./n-girl.png": "BFIt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Hffh";


//////////////////
// WEBPACK FOOTER
// ./static/skin/default/APP/Campus/Location/TeacherLocation/img ^\.\/n\-.*\.png$
// module id = Hffh
// module chunks = 393